import { render, staticRenderFns } from "./Betting.vue?vue&type=template&id=8aaec6b4&scoped=true"
import script from "./Betting.vue?vue&type=script&lang=js"
export * from "./Betting.vue?vue&type=script&lang=js"
import style0 from "./Betting.vue?vue&type=style&index=0&id=8aaec6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaec6b4",
  null
  
)

export default component.exports